import React from 'react';
import { ClockConfig, HeaderWorldClock } from '@backstage/plugin-home';
import {
  PluginCard,
  styledComponent,
  Typography,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';

type ClockProps = {
  img?: string;
  title: string;
  clockConfigs: ClockConfig[];
  customTimeFormat: Intl.DateTimeFormatOptions;
};

const Container = styledComponent('div')(({ theme }) => ({
  paddingTop: '8px',
  color: theme.palette.surface.onSurface,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',

  time: {
    color: theme.palette.surface.onSurface,
    fontSize: '36px',
  },
}));

const Block = styledComponent('div')(() => ({
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: '12px',
}));

const Clock = ({ img, title, clockConfigs, customTimeFormat }: ClockProps) => {
  const config = clockConfigs[0];
  const clock = [{ ...config, label: '' }];
  return (
    <PluginCard>
      <Container>
        <Block>
          <img src={img} alt="PH Flag" style={{ width: 40 }} />
          <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
            <Typography variant="titleMD">{title}</Typography>
            <Typography variant="bodyMD">{config.label}</Typography>
          </div>
        </Block>
        <HeaderWorldClock
          clockConfigs={clock}
          customTimeFormat={customTimeFormat}
        />
      </Container>
    </PluginCard>
  );
};

export default Clock;
